import type { SVGProps } from "react";

export function CrosshairIcon(props: SVGProps<SVGSVGElement>) {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon
		<svg
			width="24"
			height="24"
			viewBox="0 0 20 20"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M2.8 10C2.8 11.9096 3.55857 13.7409 4.90883 15.0912C6.25909 16.4414 8.09044 17.2 10 17.2M2.8 10C2.8 8.09044 3.55857 6.25909 4.90883 4.90883C6.25909 3.55857 8.09044 2.8 10 2.8M2.8 10H1M10 17.2C11.9096 17.2 13.7409 16.4414 15.0912 15.0912C16.4414 13.7409 17.2 11.9096 17.2 10M10 17.2V19M17.2 10C17.2 8.09044 16.4414 6.25909 15.0912 4.90883C13.7409 3.55857 11.9096 2.8 10 2.8M17.2 10H19M10 2.8V1M7.3 10C7.3 10.7161 7.58446 11.4028 8.09081 11.9092C8.59716 12.4155 9.28392 12.7 10 12.7C10.7161 12.7 11.4028 12.4155 11.9092 11.9092C12.4155 11.4028 12.7 10.7161 12.7 10C12.7 9.28392 12.4155 8.59716 11.9092 8.09081C11.4028 7.58446 10.7161 7.3 10 7.3C9.28392 7.3 8.59716 7.58446 8.09081 8.09081C7.58446 8.59716 7.3 9.28392 7.3 10Z" />
		</svg>
	);
}
